import { buttonClasses } from "@mui/material";
import { toPixelString } from "../../utils/index.js";
const buttonPadding = {
    small: [
        2,
        12
    ],
    medium: [
        6,
        16
    ]
};
const MuiButton = {
    defaultProps: {
        disableElevation: true
    },
    styleOverrides: {
        root: ({ theme })=>({
                ...theme.typography.button
            }),
        sizeSmall: {
            padding: toPixelString(buttonPadding.small),
            '.MuiSvgIcon-root': {
                width: '16px',
                height: '16px'
            }
        },
        sizeMedium: {
            padding: toPixelString(buttonPadding.medium),
            '.MuiSvgIcon-root': {
                width: '20px',
                height: '20px'
            }
        },
        outlinedSizeSmall: {
            padding: toPixelString(buttonPadding.small.map((p)=>p - 1))
        },
        outlinedSizeMedium: {
            padding: toPixelString(buttonPadding.medium.map((p)=>p - 1))
        },
        containedPrimary: ({ theme })=>({
                ["&:hover"]: {
                    backgroundColor: theme.palette.primary.highContrast
                },
                [`&.${buttonClasses.disabled}`]: {
                    backgroundColor: theme.palette.background.hover,
                    color: theme.palette.text.disabled
                }
            }),
        outlinedSecondary: ({ theme })=>({
                backgroundColor: theme.palette.background.container,
                color: theme.palette.text.primary,
                borderColor: theme.palette.border.prominent,
                ["&:hover"]: {
                    backgroundColor: theme.palette.background.hover,
                    borderColor: theme.palette.text.secondary
                },
                [`&.${buttonClasses.disabled}`]: {
                    color: theme.palette.text.disabled,
                    borderColor: theme.palette.border.prominent
                }
            }),
        textPrimary: ({ theme })=>({
                color: theme.palette.text.secondary,
                ["&:hover"]: {
                    color: theme.palette.text.primary,
                    backgroundColor: 'rgba(0, 0, 0, 0.04)'
                },
                [`&.${buttonClasses.disabled}`]: {
                    color: theme.palette.text.disabled
                }
            }),
        containedError: ({ theme })=>({
                ["&:hover"]: {
                    backgroundColor: theme.palette.status.error.highContrast
                },
                [`&.${buttonClasses.disabled}`]: {
                    backgroundColor: theme.palette.background.hover,
                    color: theme.palette.text.disabled
                }
            }),
        outlinedError: ({ theme })=>({
                borderColor: theme.palette.status.error.main,
                background: theme.palette.background.container,
                ["&:hover"]: {
                    backgroundColor: theme.palette.status.error.lowContrast,
                    borderColor: theme.palette.status.error.main
                },
                [`&.${buttonClasses.disabled}`]: {
                    color: theme.palette.text.disabled,
                    borderColor: theme.palette.border.prominent
                }
            }),
        textError: ({ theme })=>({
                color: theme.palette.status.error.main,
                ["&:hover"]: {
                    backgroundColor: theme.palette.status.error.lowContrast
                },
                [`&.${buttonClasses.disabled}`]: {
                    color: theme.palette.text.disabled
                }
            })
    }
};
export { MuiButton };

//# sourceMappingURL=button-overrides.js.map